import { render, staticRenderFns } from "./FirstYear.vue?vue&type=template&id=9919b2ec&"
import script from "./FirstYear.vue?vue&type=script&lang=js&"
export * from "./FirstYear.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports